import { apiClient } from './client'
import type { ApiResponse } from './client'
import type {
    InboundWebhookSubscriptionViewDto,
    InboundWebhookSubscriptionCreateDto,
    InboundWebhookSubscriptionUpdateDto,
    InboundWebhookKeyRevealDto,
    InboundWebhookSummaryDto,
} from '@/types/inboundWebhooks'

export const inboundWebhooksApi = {
    // Company-scoped management. Company-admin only, server side.
    getSubscriptions: (clientCompanyId: string): Promise<ApiResponse<InboundWebhookSubscriptionViewDto[]>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/InboundWebhooks`),

    createSubscription: (
        clientCompanyId: string,
        dto: InboundWebhookSubscriptionCreateDto
    ): Promise<ApiResponse<InboundWebhookKeyRevealDto>> =>
        apiClient.post(`/api/ClientCompanies/${clientCompanyId}/InboundWebhooks`, dto),

    updateSubscription: (
        clientCompanyId: string,
        id: string,
        dto: InboundWebhookSubscriptionUpdateDto
    ): Promise<ApiResponse<InboundWebhookSubscriptionViewDto>> =>
        apiClient.put(`/api/ClientCompanies/${clientCompanyId}/InboundWebhooks/${id}`, dto),

    deleteSubscription: (clientCompanyId: string, id: string): Promise<ApiResponse<null>> =>
        apiClient.delete(`/api/ClientCompanies/${clientCompanyId}/InboundWebhooks/${id}`),

    rotateKey: (clientCompanyId: string, id: string): Promise<ApiResponse<InboundWebhookKeyRevealDto>> =>
        apiClient.post(`/api/ClientCompanies/${clientCompanyId}/InboundWebhooks/${id}/Key`, {}),

    // Workspace-scoped and non-secret, so the web and workspace settings screens can use it
    // without company-admin rights.
    getForWorkspace: (clientCompanyId: string, workspaceId: string): Promise<ApiResponse<InboundWebhookSummaryDto[]>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/InboundWebhooks`),
}
